module.exports = "<nav role=\"navigation\" class=\"signupNavigation navigation\">\r\n    <h2 class=\"sr-only\">Authentication navigation</h2>\r\n    <ul class=\"navigation-items\">\r\n        <li>\r\n            <a ui-sref=\"shop.authentication.signup\" ui-sref-active=\"is-active\" class=\"navigation-link\">Sign up</a>\r\n        </li>\r\n    </ul>\r\n</nav>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/signup/signup-navigation-template.html
 ** module id = 1022
 ** module chunks = 1
 **/